<template>
  <Editor
    v-model="model"
    :init="editorInit"
    :tinymceScriptSrc="tinymceScriptSrc"
  />
</template>

<script setup>
import { computed } from 'vue'
import Editor from '@tinymce/tinymce-vue'

// v-model
const props = defineProps({ modelValue: { type: String, default: '' } })
const emit = defineEmits(['update:modelValue'])
const model = computed({
  get: () => props.modelValue,
  set: v => emit('update:modelValue', v)
})

// 🔒 Load TinyMCE from your own domain (served from /public)
const tinymceScriptSrc = '/tinymce/tinymce.min.js'

// TinyMCE init
const editorInit = {
  // ✅ Tell TinyMCE you’re on the free GPL license
  license_key: 'gpl',

  // ✅ Make TinyMCE look for assets in /tinymce and use the .min files
  base_url: '/tinymce',
  suffix: '.min',

  height: 300,
  menubar: false,

  branding: false,

  // Use ONLY plugins you actually have in /public/tinymce/plugins/*
  // All below exist in TinyMCE 6 OSS and live at plugin.min.js
  plugins: 'lists link image code table',
  toolbar:
    'undo redo | header | bold italic underline strikethrough superscript subscript code | align | bold italic underline | bullist numlist | link image table | code',
    // 'undo redo | styles | align | bold italic underline | bullist numlist | link image table | code',

  // Optional: ensure images/paste previews work under CSP
  // images_upload_url: '/api/upload',
}
</script>